/**
 * Identificadores de navegador que Facebook usa para casar un evento enviado server-side
 * (Conversions API) con la sesión real del usuario y con las campañas que la originaron.
 *
 *  - `_fbp`: cookie de primera parte que siembra el Pixel al cargar la web.
 *  - `_fbc`: identificador del clic en el anuncio. El Pixel lo siembra en cookie al aterrizar
 *    con `fbclid` en la URL, pero ese parámetro solo está en esa PRIMERA carga: en páginas
 *    profundas del flujo de inscripción (justificante, por ejemplo) ya no existe, y sin leer
 *    la cookie el evento llegaría a Facebook sin atribución al anuncio.
 *
 * Se mantiene la precedencia que ya usaban los call sites existentes — el `fbclid` de la URL
 * gana a la cookie, porque en la carga de aterrizaje el Pixel puede no haberla escrito todavía —
 * y se añade la cookie como fallback, que es lo que hace utilizable el helper fuera de la landing.
 *
 * Solo debe llamarse tras comprobar `hasAdvertisementConsent()`: sin consentimiento de la
 * categoría `advertisement` estos identificadores no pueden salir del navegador.
 */
export function getFacebookBrowserIds(): { fbp?: string; fbc?: string } {
  if (typeof document === 'undefined') return {};

  const readCookie = (name: string): string | undefined =>
    document.cookie.split('; ').find(c => c.startsWith(`${name}=`))?.split('=')[1];

  const fbclid = new URLSearchParams(window.location.search).get('fbclid');

  return {
    fbp: readCookie('_fbp'),
    fbc: fbclid ? `fb.1.${Date.now()}.${fbclid}` : readCookie('_fbc'),
  };
}
